import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const DeletedSessionDetailsPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.DeletedSessionDetails />
    </div>
  );
};

export default DeletedSessionDetailsPage;
